import { gql } from '@apollo/client';
import type { TimestampInMillis } from '@cobliteam/common-types';
import moment from 'moment';
import graphQLRequester from '../../request/GraphQLRequester';
import TimeZone from '../../request/Timezone';
import type { HomeProductivity } from './CommonTypes';

export class GraphQLPerformanceRequester {
  public getHomePerformanceSummary = (startTimestamp: TimestampInMillis, endTimestamp: TimestampInMillis, groupIds?: string[]): Promise<HomeProductivity> => {
    const timeZone = TimeZone.getTimezone();
    const startDate = moment(startTimestamp).toISOString(true);
    const endDate = moment(endTimestamp).toISOString(true);

    return graphQLRequester
      .query<{ homeProductivitySummary: HomeProductivity }>({
        query: gql`
          query HomeProductivity(
            $start_date: String!
            $end_date: String!
            $tz: String!
            $groupIds: [String]
          ) {
            homeProductivitySummary(
              start_date: $start_date
              end_date: $end_date
              tz: $tz
              groupIds: $groupIds
            ) {
              averageStopTimeInMinutes
              averageIdleOnTimeInMinutes
              averageEngineOnTimeInMinutes
            }
          }
        `,
        variables: {
          start_date: startDate,
          end_date: endDate,
          tz: timeZone,
          groupIds: groupIds,
        },
      })
      .then((graphQlResponse) => graphQlResponse.homeProductivitySummary);
  };
}

export default GraphQLPerformanceRequester;
